<div class="tabs">
  <button [class.active]="activeTab === 0" (click)="activeTab = 0">E-File Push</button>
  <button [class.active]="activeTab === 1" (click)="activeTab = 1">Migration History</button>
</div>

@if (activeTab === 0) {
<div class="push-shell">
  <div class="row">
    <label>Tax Year</label>
    <select [(ngModel)]="selectedTaxYear" (ngModelChange)="onTaxYearChange()">
      @for (y of taxYears; track $index) {
<option [ngValue]="y">{{ y.label || y.value }}</option>
}
    </select>
  </div>
  <div class="row">
    <label>Scenario</label>
    <select [(ngModel)]="selectedScenario" (ngModelChange)="onScenarioChange()">
      @for (s of selectedTaxYear?.scenarios || []; track $index) {
<option [ngValue]="s">{{ s.scenario_desc || s.scenario }}</option>
}
    </select>
  </div>
  <div class="row">
    <label>Consol Group</label>
    <select [(ngModel)]="selectedConsolGroup" (ngModelChange)="loadTaxPayers()">
      @for (g of consolGroups; track $index) {
<option [ngValue]="g">{{ g.GROUP_NAME }}</option>
}
    </select>
  </div>

  <div class="row">
    <label>Tax Payers</label>
    <div class="chips">
      @for (tp of taxPayers; track $index) {
<label>
        <input type="checkbox" [checked]="isTaxPayerSelected(tp)" (change)="onTaxPayerToggle(tp)">
        {{ tp.label || tp.tax_payer || tp.VALUE }}
      </label>
}
    </div>
  </div>

  <table class="table table-bordered">
    <thead>
      <tr><th></th><th>System</th></tr>
    </thead>
    <tbody>
      @if (loadingSystems) {
<tr><td colspan="2"><i class="fa fa-spinner fa-spin"></i></td></tr>
}
      @for (e of efiles; track $index) {
<tr>
        <td><input type="checkbox" [(ngModel)]="e.selected"></td>
        <td>{{ e.system_name }}</td>
      </tr>
}
    </tbody>
  </table>

  <button class="btn btn-info" [disabled]="!hasSelectedSystems() || pushing" (click)="push()">
    {{ pushing ? 'Pushing...' : 'Push to E-file' }}
  </button>
</div>
}

@if (activeTab === 1) {
<div>
  <gtw-efile-migration-history
    base-urls="{{ baseURLs | json }}"
    header-data="{{ headerData | json }}"
    row-data="{{ rowData | json }}">
  </gtw-efile-migration-history>
</div>
}
